export const ARTICLES_PATH = "/portal/resources/articles";
